
function promiseUrlFetch (method, url, data, options) {
  return new Promise(function(resolve, reject) {
    try {
      var xhr = new XMLHttpRequest()
      xhr.onload = function () {
        if (this.status === 200) {
          resolve({
            status: this.status || 500,
            statusText: this.statusText || '',
            response: this.response || ''
          })
        }
        else {
          reject({
            status: this.status || 500,
            statusText: this.statusText || '',
            response: this.response || ''
          })
        }
      }
      xhr.open(method, url, true)

      options = options || {}
      if (options.type) xhr.responseType = options.type
      if (options.headers) {
        for (var hdr in options.headers) {
          xhr.setRequestHeader(hdr, options.headers[hdr])
        }
      }
      data = data || null
      if (data && typeof data === 'object') data = JSON.stringify(data)
      xhr.send(data)
    }
    catch (ex) {
      reject(ex)
    }
  })
}

export default {
  get: function (url, data, options) {
    return promiseUrlFetch('GET', url, data, options)
  },
  post: function (url, data, options) {
    return promiseUrlFetch('POST', url, data, options)
  }
}
